import axios from 'axios';

async function ObtenerServicio(prmServicio: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_servicios"
    
    const datosEnvio = {"usuario": "mpatti", "clave": "all2GetHer_!", "id_servicio": prmServicio}
    
    try {
        const response = await axios.post(url, datosEnvio);
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerServicio;